<template>
  <section v-if="error">
  <br/>
  <p class="error">{{ error }}</p>
  </section>
  <section class="page-container grid-container" v-if="!error && loaded">
    <div class="grid-container wizard">
      
        <section>    
        <div class="grid-x grid-margin-x">
            <div class="cell small-12">
                <a @click="router.back()">← Back</a>
            </div>
        </div>
        </section>

        <section>
            <div class="grid-x grid-margin-x">
                <div class="cell small-12">
                    <span v-if="task.taskStatus !=='SuccessfullyCompleted'">
                        <h1 class="text-2xl font-bold">Contract Signing</h1>
                        <p>The below person has been provided as the signatory for your company.</p>
                        <p>They will receive an email containing our service level agreement from our partner Docusign, requesting an electronic signature.</p>
                    </span>
                    <span v-else>
                        <h1 class="text-2xl font-bold">Contract Signing Complete</h1>
                        <p>The contract has been signed by your signatory.</p>
                        <p>You will receive a copy of the signed contract via email.</p>
                    </span>
                    <table>
                    <thead>
                        <tr>
                        <th>Name</th>
                        <th>Job Title</th>
                        <th>Email Address</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{signatoryContact.firstName}} {{signatoryContact.lastName}}</td>
                            <td>{{signatoryContact.jobTitle}}</td>
                            <td>{{signatoryContact.email}}</td>
                        </tr>
                    </tbody>
                    </table>
                    <br/>
                    <button class="btn btn-secondary" @click="router.push({ name: 'Home' })">Return to Home</button>
                </div>
            </div>
        </section>

        


</div>


  </section>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useClientStore } from '@/stores/client'
import { getContractSigningTask } from '@/services/implementationmanagement.api';
import { splitByCapitals } from '@/helpers/strings';

const router  = useRouter()
const loaded = ref(false);
const taskId = router.currentRoute.value.params.taskId;
const error = ref(null);
const task = ref(null);
const signatoryContact = ref(null);

const errorString = 'An error has occurred. Please contact your Qtac account manager.';


onMounted(async () => {
    const client = useClientStore();

    try {
        var contractSigningTask = await getContractSigningTask(taskId);

        if(contractSigningTask.status !== 200 || contractSigningTask.data === null || contractSigningTask.data === undefined) {
            error.value = errorString;
            return null;
        }

        if(client == null) {
            error.value = errorString;
            return null;
        }

        task.value = contractSigningTask.data;

        signatoryContact.value = client.contacts.find(c => c.isSlaSignatory === true) || null;

        if(signatoryContact.value == null) {
            error.value = errorString;
            return null;
        }

    } catch (err) {
        error.value = errorString;
        console.error(err);
    }




loaded.value = true;
})


</script>

